import { A_Channel } from "@adaas/a-utils/a-channel";



export class A_WebsocketsChannel extends A_Channel {
    // Websockets specific implementations would go here





    async request(params: any): Promise<any> {

    }
}